export const DEBUG = false;
export const CURRENT_VERESION = DEBUG ? "5.6.1" : VERSION;
export const UNI_VERSION = '7.2.0';
export const VERSION5_2_0 = true;
export const VERSION5_2_3 = true;
export const VERSION5_2_4 = true;
export const VERSION5_3_0 = true;
export const VERSION5_3_1 = true;
export const VERSION5_4_0 = true;
export const VERSION5_5_0 = true;
export const VERSION5_5_1 = true;
export const VERSION5_6_0 = true;

export const VERSION5_8_0 = true;

export const VERSION6_0_0 = true;

export const VERSION6_5_1 = true;
/**
 * 版本比较
 * @desc version>=CURRENT_VERESION true else false
 * @param {string} version
 * @return {boolean}
 */
export const egtVersion = (version) => {
  const verArray = version.split('.');
  const curArray = CURRENT_VERESION.split('.');
  for (let i = 0; i < verArray.length; i++) {
    if (verArray[i] > curArray[i]) return true;
    if (verArray[i] === curArray[i]) continue;
    if (verArray[i] < curArray[i]) return false;
  }
  return true;
}


/**
 * 版本比较
 * @desc version<=CURRENT_VERESION true else false
 * @param {string} version
 * @return {boolean}
 */
export const eltVersion = (version) => {
  const verArray = version.split('.').map(r => parseFloat(r));
  const curArray = CURRENT_VERESION.split('.').map(r => parseFloat(r));
  for (let i = 0; i < verArray.length; i++) {
    if (verArray[i] < curArray[i]) return true;
    if (verArray[i] === curArray[i]) continue;
    if (verArray[i] > curArray[i]) return false;
  }
  return true;
}



// WEBPACK FOOTER //
// ./src/lib/version.js